/**
 * SamplingEditor 组件常量定义
 */

/** 图像 MIME 类型 */
export const IMAGE_MIME_TYPE_PNG = 'image/png' as const

/** 错误消息 */
export const ERROR_CANVAS_TO_BLOB_FAILED = 'Canvas toBlob 失败'
